export const getDaysLeft = (
    paymentExpDate: number
): number => {
    const expDate= new Date(paymentExpDate * 1000);
    const currentDay = new Date();
    return (expDate.getTime() - currentDay.getTime()) / (1000 * 60 * 60 * 24)
};
